import React from 'react'
import PropTypes from 'prop-types'
import SupplierShape from './prop_shapes/supplier'
import Section from './Section'
import Overview from './Overview'

const OverviewSection = ({ supplier, editButton }) => {
  return (
    <Section idText='supplier-details'>
      {editButton && (
        <div className='padding-3 edit-hero'>
          <h3>Edit or add key information</h3>
          {editButton}
        </div>
      )}
      <Overview supplier={supplier} />
    </Section>
  )
}

OverviewSection.propTypes = {
  editButton: PropTypes.element,
  supplier: SupplierShape
}

export default OverviewSection
